import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Button.styles';

const Button = props => {
  const { styles: customStyles, disabled, ...rest } = props;
  return (
    <button
      className={css(styles.base, customStyles, disabled && styles.disabled)}
      disabled={disabled}
      {...rest}
    >
      {props.children}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/inputs/button/Button.js